import React from 'react';
import withIcon from '../utilities/withIcon';

const IconHappyFilled = () => {
  return (
    <g>
      <path d="m8 .125a7.875 7.875 0 1 0 7.875 7.875 7.8839 7.8839 0 0 0 -7.875-7.875zm-3.3129 5.2833a.9829.9829 0 1 1 -.983.9829.9829.9829 0 0 1 .983-.9829zm7.497 4.3317a4.4245 4.4245 0 0 1 -8.3159 0 .6.6 0 1 1 1.1289-.4072 3.2244 3.2244 0 0 0 6.0581 0 .6.6 0 1 1 1.1289.4072zm-.7812-2.3657a.9829.9829 0 1 1 .9829-.9829.9829.9829 0 0 1 -.983.9827z" />
    </g>
  );
};

export default withIcon(IconHappyFilled);
